export const useForm = (controller) => {
  Object.assign(controller, {
    submitForm(event) {
      event.preventDefault()
      this.element.closest('form').submit()
    }
  })
}
